import React from 'react';
import { css } from 'emotion';
import Navbar from '../components/Navbar';
import BannerImages from '../components/BannerImages';
import Filters from '../components/Filters';
import Results from '../components/Results';

// If you want to remove the images from left side, remove Banner.left and
// in the container styles change the grid-template-columns to 0 1fr 0.5fr

// Similarily if you want to remove all right images, remove Banner.Right and
// in the container styles change grid-template-columns to 0.5fr 1fr 0

// Note in mobile screen put the right section images in Left it will become scrollable
// Check line 57

const leftImage = {
	src:
		'https://images.unsplash.com/photo-1551803021-b00a39752dfe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1951&q=80',
	alt: 'Left Top Image',
};

const rightImage = {
	src:
		'https://images.unsplash.com/photo-1523728778454-06bedf489d10?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60',
	alt: 'Left Bottom Image',
};

const container = css`
	display: grid;
	align-items: start;
	grid-gap: 10px;
	margin-top: 60px;
	padding: 10px 10px 0;
	grid-template-columns: 0.5fr 1fr 0.5fr;
	@media (max-width: 1024px) {
		grid-template-columns: 0.6fr 1fr 0.6fr;
	}
	@media (max-width: 768px) {
		grid-template-columns: 0.8fr 1fr 0.8fr;
	}
	@media (max-width: 576px) {
		grid-template-columns: auto;
		position: inherit;
	}
`;

const Home = () => {
	const isMobile = window.innerWidth < 576;
	return (
		<React.Fragment>
			<Navbar />
			<div className={container}>
				<BannerImages>
					<BannerImages.Left>
						<img src={leftImage.src} alt={leftImage.alt} />
						{isMobile ? <img src={rightImage.src} alt={rightImage.alt} /> : null}
					</BannerImages.Left>
					<div>
						<Filters />
						<Results />
					</div>
					<BannerImages.Right>
						<img src={rightImage.src} alt={rightImage.alt} />
					</BannerImages.Right>
				</BannerImages>
			</div>
		</React.Fragment>
	);
};

export default Home;
